import { render, staticRenderFns } from "./index_old.vue?vue&type=template&id=5d727d4b&scoped=true"
import script from "./index_old.vue?vue&type=script&lang=js"
export * from "./index_old.vue?vue&type=script&lang=js"
import style0 from "./index_old.vue?vue&type=style&index=0&id=5d727d4b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d727d4b",
  null
  
)

export default component.exports